/**
 * Embla Carousel + Auto Scroll（ボタン・ON/OFF なしで常時オートスクロール）
 */

import EmblaCarousel from "embla-carousel";
import AutoScroll from "embla-carousel-auto-scroll";

const DEFAULT_OPTIONS = {
	loop: true,
	align: "start",
	draggable: true,
};
const isMobile = window.matchMedia("(max-width: 767px)").matches;

const DEFAULT_AUTOSCROLL_OPTIONS = {
	speed: isMobile ? 0.5 : 1, // モバイルだけ遅く
	startDelay: 1000,
	direction: "forward",
};

/**
 * オートスクロール付き Embla を初期化する
 * @param {HTMLElement} viewport - .embla__viewport など Embla の viewport 要素
 * @param {Object} [options] - Embla のオプション（loop は true 推奨）
 * @param {Object} [autoScrollOptions] - AutoScroll のオプション（speed, startDelay, direction など）
 * @returns {Object} emblaApi
 */
export function createEmblaWithAutoScroll(viewport, options = {}, autoScrollOptions = {}) {
	const emblaOptions = { ...DEFAULT_OPTIONS, ...options };
	const scrollOptions = { ...DEFAULT_AUTOSCROLL_OPTIONS, ...autoScrollOptions };

	const emblaApi = EmblaCarousel(viewport, emblaOptions, [AutoScroll(scrollOptions)]);

	emblaApi.plugins().autoScroll?.play();

	return emblaApi;
}
